import Buttons from '@klv/molecules/buttons';
import KlaviyoForm from '@klv/atoms/klaviyo-form';
import HubspotForm from '@klv/atoms/hubspot-form';
import Quote from '@klv/molecules/quote';
import { generateClassName, styleBadge } from '@klv/shared/utils/functions';
import { getBackgroundType } from '@klv/utils/wrapper/functions';

import * as styles from './styles/twoColumnBody.module.scss';
import { isQuote } from '../utils';

import type { ITwoColumnBodyProps, TMediaAlignment } from '../types';
import type { TColorVariant } from '@klv/shared/styles/types';

export const TwoColumnBody = ({
  body,
  buttons,
  backgroundColor = 'light',
  mediaAlignment,
  CustomContent,
}: ITwoColumnBodyProps) => {
  const hasQuote = isQuote(body);
  const backgroundType = getBackgroundType(backgroundColor);
  const hasFormId = (body && body?.length > 0 && body[0]?.formId);

  return (
    <div className={generateClassName([styles.gridTextLower, styles[mediaAlignment as TMediaAlignment]])}>
      {body && body?.length > 0 && (
        <div className={`p2 ${styles.body}`}>
          {(body[0]?.bodyType === 'RichText' || hasFormId) && (
            <div className={styles.bodyText} dangerouslySetInnerHTML={{ __html: styleBadge(body[0].richText) }} />
          )}
          {(body[0]?.bodyType === 'KlaviyoForm' && hasFormId) && (
            <KlaviyoForm formId={body[0].formId} />
          )}
          {/* We do not include header or subheader text since this would be redundant with the headline and subhead above */}
          {(body[0]?.bodyType === 'HubspotForm' && hasFormId) && (
            <HubspotForm {...body[0]} hubspotHeaderText={''} hubspotSubheaderText={''} />
          )}
          {hasQuote && body[0].quote && (
            <Quote
              backgroundColor={backgroundType as TColorVariant}
              quote={body[0].quote}
              attribution={body[0].attribution}
            />
          )}
        </div>
      )}
      {CustomContent || (
        <Buttons
          buttons={buttons}
          variants={['ghost', 'tertiary']}
          buttonColor={backgroundType === 'light' ? 'dark' : 'light'}
        />
      )}
    </div>
  );
}; 
